function initSizeGuide() {
  let isEventBound = false // Flag to track if we've bound the event

  const observer = new MutationObserver(mutations => {
    const triggerLink = document.querySelector('[class*="size-guide-btn-23p5"]')

    if (triggerLink && !isEventBound) {
      // triggerLink.addEventListener('click', event => {
      //   event.preventDefault()
      //   const sizeGuideUrl = triggerLink.getAttribute('data-size-guide-url')
      //   openModal(sizeGuideUrl)
      // })
      // isEventBound = true // Set flag but don't disconnect observer
    }
  })

  // Observe with more detailed configuration
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true, // Watch for attribute changes
    characterData: true // Watch for text content changes
  })
}
function initCustomizer() {
  let isEventBound = false // Flag to track if we've bound the event

  const observer = new MutationObserver(mutations => {
    // Check for mobile and desktop wrappers
    const mobileWrapper = document.querySelector('.customizable-wrapper.mobile')
    const desktopWrapper = document.querySelector('.customizable-wrapper.desktop')
    // Determine which wrapper is active based on display style
    let activeWrapper = null
    if (mobileWrapper && getComputedStyle(mobileWrapper).display !== 'none') {
      activeWrapper = mobileWrapper
    } else if (desktopWrapper && getComputedStyle(desktopWrapper).display !== 'none') {
      activeWrapper = desktopWrapper
    }

    // Look for trigger button within the active wrapper
    const triggerButton = activeWrapper ? activeWrapper.querySelector('.customize-btn-23p5') : null

    if (triggerButton && !isEventBound) {
      triggerButton.addEventListener('click', event => {
        event.preventDefault()
        const customizeUrl = triggerButton.getAttribute('data-customize-url')
        const customizerId = generateCustomizerId() // Generate a unique ID

        // Extract product ID from URL or page
        const productId = getProductId()

        // Add hidden properties to cart form before opening customizer
        // addCustomPropertiesToCartForm(customizerId, productId)

        // Extract shop URL from current page
        const shopUrl = window.location.hostname
        const fullCustomizeUrl = `${customizeUrl}?customize_id=${customizerId}&shop_url=${shopUrl}&store_type=INTERNAL`

        // GTM event
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'customize_color_click',
          product_id: productId,
          customize_id: customizerId
        })
        openCustomizerModal(fullCustomizeUrl)
      })
      isEventBound = true
    }
  })

  // Observe with more detailed configuration
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true
  })
}
// Generate a unique customizer ID (5 alphanumeric characters)
function generateCustomizerId() {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let result = ''
  for (let i = 0; i < 5; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

// Get product ID from current page
function getProductId() {
  // Method 1: Look for the 23point5 product ID input (primary method)
  const productIdInput = document.getElementById('23point5-product-id')
  if (productIdInput && productIdInput.value) {
    return productIdInput.value
  }

  // Method 2: Check if there's a product ID in the URL
  const urlParams = new URLSearchParams(window.location.search)
  const urlProductId = urlParams.get('product_id')
  if (urlProductId) return urlProductId

  // Method 3: Look for product ID in meta tags
  const metaProductId = document.querySelector('meta[name="product-id"]')
  if (metaProductId) return metaProductId.getAttribute('content')

  // Method 4: Look for product form and extract from variant ID input
  const productForm = document.querySelector('form[data-type="add-to-cart-form"]')
  if (productForm) {
    const variantInput = productForm.querySelector('input[name="id"]')
    if (variantInput && variantInput.value) {
      // Try to extract product ID from variant ID (this may not always work)
      return variantInput.value
    }
  }

  // Method 5: Look for product JSON script tag
  const productJsonScript = document.querySelector('script[data-product-json]')
  if (productJsonScript) {
    try {
      const productData = JSON.parse(productJsonScript.textContent)
      return productData.id
    } catch (e) {
      console.warn('Could not parse product JSON:', e)
    }
  }

  // Method 6: Extract from URL path for product pages
  const pathMatch = window.location.pathname.match(/\/products\/([^\/]+)/)
  if (pathMatch) {
    return pathMatch[1] // Return product handle as fallback
  }

  console.warn('Could not determine product ID')
  return null
}

// Add custom properties to the cart form
function addCustomPropertiesToCartForm(customizerId, productId) {
  // Find the product form
  console.log('Adding custom properties to cart form:', {
    customizerId,
    productId
  })
  const productForm = document.querySelector('form[data-type="add-to-cart-form"]')
  if (!productForm) {
    console.warn('Product form not found')
    return
  }

  // Remove existing custom properties if they exist
  const existingCustomizeId = productForm.querySelector('input[name="properties[customize_id]"]')
  const existingPreviewUrl = productForm.querySelector('input[name="properties[preview_url]"]')

  if (existingCustomizeId) existingCustomizeId.remove()
  if (existingPreviewUrl) existingPreviewUrl.remove()

  // Create customize_id hidden input
  const customizeIdInput = document.createElement('input')
  customizeIdInput.type = 'hidden'
  customizeIdInput.name = 'properties[Customized ID]'
  customizeIdInput.value = customizerId

  // Create preview_url hidden input
  const previewUrlInput = document.createElement('input')
  previewUrlInput.type = 'hidden'
  previewUrlInput.name = 'properties[Preview URL]'
  previewUrlInput.value = `https://shop.23point5.com/customize/preview/${productId}?customize_id=${customizerId}&store_type=INTERNAL`

  // Add inputs to the form
  productForm.appendChild(customizeIdInput)
  productForm.appendChild(previewUrlInput)
}
function openCustomizerModal(customizeUrl) {
  // Create modal container
  const modal = document.createElement('div')
  modal.className = 'customizer-modal'
  modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
  `

  // Create modal content
  const modalContent = document.createElement('div')
  modalContent.className = 'customizer-modal-content'
  modalContent.style.cssText = `
    flex: 1;
    width: 100%;
    height: 100%;
    position: relative;
    background: white;
    transform: translateY(20px);
    opacity: 0;
    transition: all 0.3s ease-in-out;
  `

  // Create loading message
  const loadingMessage = document.createElement('div')
  loadingMessage.className = 'customizer-loading-message'
  loadingMessage.style.cssText = `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
    font-size: 18px;
    color: #666;
    z-index: 2;
    opacity: 1;
    transition: opacity 0.3s ease-in-out;
  `
  loadingMessage.textContent = 'Loading 3D assets...'

  // Create close button
  const closeButton = document.createElement('button')
  closeButton.innerHTML = '×'
  closeButton.className = 'customizer-modal-close'
  closeButton.style.cssText = `
    position: absolute;
    right: 20px;
    top: 5px;
    border: none;
    background: none;
    font-size: 32px;
    cursor: pointer;
    padding: 8px 12px;
    line-height: 1;
    z-index: 3;
    color: #333;
    -webkit-tap-highlight-color: transparent;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
  `

  // Create iframe
  const iframe = document.createElement('iframe')
  iframe.src = customizeUrl
  iframe.style.cssText = `
    width: 100%;
    height: 100%;
    border: none;
    display: block;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
  `

  // Handle iframe load
  iframe.addEventListener('load', () => {
    // Fade out loading message and fade in iframe
    loadingMessage.style.opacity = '0'
    iframe.style.opacity = '1'

    // Remove loading message after fade out
    setTimeout(() => {
      loadingMessage.remove()
    }, 300)
  })

  // Add close functionality
  const closeModal = () => {
    modal.style.opacity = '0'
    modalContent.style.opacity = '0'
    modalContent.style.transform = 'translateY(20px)'
    closeButton.style.opacity = '0'
    loadingMessage.style.opacity = '0'

    // Wait for animation to complete before removing
    setTimeout(() => {
      modal.remove()
      document.body.style.overflow = ''
    }, 300)
  }
  closeButton.addEventListener('click', closeModal)
  closeButton.addEventListener('touchend', closeModal)

  // Prevent body scrolling when modal is open
  document.body.style.overflow = 'hidden'

  // Assemble modal
  modalContent.appendChild(loadingMessage)
  modalContent.appendChild(closeButton)
  modalContent.appendChild(iframe)
  modal.appendChild(modalContent)
  document.body.appendChild(modal)

  // Trigger animation
  requestAnimationFrame(() => {
    modal.style.opacity = '1'
    modalContent.style.opacity = '1'
    modalContent.style.transform = 'translateY(0)'
    closeButton.style.opacity = '1'
  })
}

// Try both immediate execution and DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initSizeGuide()
    initCustomizer()
  })
} else {
  initSizeGuide()
  initCustomizer()
}

function openModal(sizeGuideUrl) {
  const isMobile = window.innerWidth < 768
  // Create modal container
  const modal = document.createElement('div')
  modal.className = 'size-guide-modal'
  modal.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: ${isMobile ? 'unset' : 'center'};
      align-items: ${isMobile ? 'unset' : 'center'};
      z-index: 9999;
      padding: 8px; /* Add padding for mobile */

      @media (min-width: 768px) {
        height: auto;
        justify-content: unset;
        align-items: unset;
        max-height: 100%;
      }
  `
  // Create modal content
  const modalContent = document.createElement('div')
  modalContent.className = 'size-guide-modal-content'

  // Create and apply specific styles for this instance
  const uniqueClassName = 'size-guide-modal-content-' + Date.now()
  modalContent.classList.add(uniqueClassName)

  const styleSheet = document.createElement('style')
  styleSheet.textContent = `
    .${uniqueClassName} {
      background: white;
      padding: ${isMobile ? '8px' : '16px'};
      border-radius: 8px;
      position: relative;
      width: 100%;
      max-width: 1025px;
      max-height: 90vh;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      height: ${isMobile ? 'auto' : 'unset'};
    }
    
    .${uniqueClassName}::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      background-color: transparent;
    }

    .${uniqueClassName}::-webkit-scrollbar-track {
      background: transparent;
    }

    .${uniqueClassName}::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.3);
      border-radius: 4px;
      transition: background-color 0.2s;
    }

    .${uniqueClassName}::-webkit-scrollbar-thumb:hover {
      background-color: rgba(0, 0, 0, 0.5);
    }

    .${uniqueClassName}:hover::-webkit-scrollbar {
      opacity: 1;
    }

    .${uniqueClassName}:hover::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.3);
    }

    .${uniqueClassName}:not(:hover)::-webkit-scrollbar-thumb {
      background-color: transparent;
    }
  `
  document.head.appendChild(styleSheet)

  // Create close button
  const closeButton = document.createElement('button')
  closeButton.innerHTML = `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `
  closeButton.className = 'size-guide-modal-close'
  closeButton.style.cssText = `
      position: absolute;
      right: 10px;
      top: 10px;
      border: none;
      background: none;
      cursor: pointer;
      padding: 8px;
      line-height: 1;
      z-index: 1;
      color: #333;
      display: flex;
      align-items: center;
      justify-content: center;
      -webkit-tap-highlight-color: transparent;
  `

  // Create iframe
  const iframe = document.createElement('iframe')
  iframe.src = sizeGuideUrl || 'https://www.23point5.com'
  iframe.style.cssText = `
      width: 100%;
      height: ${isMobile ? '100vh' : '80vh'};
      border: none;
      max-width: 100%; /* Ensure iframe doesn't overflow */
      display: block; /* Fix potential inline spacing issues */
  `

  // Add close functionality with touch events
  const closeModal = () => {
    modal.remove()
    document.body.style.overflow = ''
  }
  closeButton.addEventListener('click', closeModal)
  closeButton.addEventListener('touchend', closeModal) // Add touch event
  modal.addEventListener('click', e => {
    if (e.target === modal) closeModal()
  })
  modal.addEventListener('touchend', e => {
    // Add touch event
    if (e.target === modal) closeModal()
  })

  // Prevent body scrolling when modal is open
  document.body.style.overflow = 'hidden'

  // Restore body scrolling when modal is closed
  const restoreScrolling = () => {
    document.body.style.overflow = ''
  }
  closeButton.addEventListener('click', restoreScrolling)
  modal.addEventListener('click', e => {
    if (e.target === modal) restoreScrolling()
  })

  // Assemble modal
  modalContent.appendChild(closeButton)
  modalContent.appendChild(iframe)
  modal.appendChild(modalContent)
  document.body.appendChild(modal)
}
